import * as XLSX from 'xlsx';

import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatDatepickerToggle, MatDateRangeInput, MatDateRangePicker, MatEndDate, MatStartDate } from '@angular/material/datepicker';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormField, MatLabel, MatSuffix } from '@angular/material/form-field';
import { SortService } from '../../shared/sort/sort.service';
import { WorkService } from '../work.service';
import { WorkColumnsService } from '../work-columns/work-columns.service';


@Component({
  selector: 'app-work-export-dialog',
  imports: [
    MatButton,
    MatCheckbox,
    MatStartDate,
    MatEndDate,
    MatDialogModule,
    MatFormField,
    MatLabel,
    MatDateRangeInput,
    MatDatepickerToggle,
    MatDateRangePicker,
    MatSuffix,
    FormsModule,
  ],
  templateUrl: './work-export-dialog.component.html',
  styleUrl: './work-export-dialog.component.scss'
})
export class WorkExportDialogComponent {

  data = inject(MAT_DIALOG_DATA);

  dialogRef = inject(MatDialogRef<WorkExportDialogComponent>);

  sortService = inject(SortService);

  workColumnsService = inject(WorkColumnsService);

  workService = inject(WorkService);

  additionalFilters = {
    start_created_at: null,
    end_created_at: null,
    start_completed_at: null,
    end_completed_at: null,
    include_completed: false,
  }

  filters = this.data.filters || {};

  columns = this.data.columns || [];

  export() {
    this.sortService.getDefault('pending').then((sortValue) => {
      const filters = {...this.filters, ...this.additionalFilters };
      this.workService.index(filters, -1, sortValue).toPromise().then((value:any) => {
        const excelFileName = 'Trabajos';
        const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.formatJson(value.body.items, this.columns));
        const workbook: XLSX.WorkBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Data');
        const today = new Date();
        const date = `${today.getFullYear()}${today.getMonth() + 1}${today.getDate()}`;
        const time = `${today.getHours()}${today.getMinutes()}${today.getSeconds()}`;
        const name = excelFileName + date + time;
        XLSX.writeFile(workbook, `${name}.xlsx`);
        this.dialogRef.close();
      });
    });
  }

  private formatJson(data, columns) {
    return this.workColumnsService.toExcel(data, columns);
  }
}
